import script from "./details-front.vue?vue&type=script&setup=true&lang=ts"
export * from "./details-front.vue?vue&type=script&setup=true&lang=ts"

import "./details-front.vue?vue&type=style&index=0&id=48fd3195&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48fd3195"]])

export default __exports__